import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { QData } from "../../../types/basic-type-list";
import { IndustryDetail, IndustryItem } from "@src/types/api/industry";

export async function saveIndustry(
  data: IndustryDetail
): Promise<AxiosResponse<TResponse<IndustryDetail>>> {
  return axios.post<TResponse<IndustryDetail>>(
    API_ENDPOINTS.INDUSTRY_SAVE,
    data
  );
}

export async function industryDetail(
  slug: string
): Promise<AxiosResponse<TResponse<IndustryDetail>>> {
  return axios.get<TResponse<IndustryDetail>>(
    `${API_ENDPOINTS.INDUSTRY_DETAIL}/${slug}`
  );
}

export async function listIndustry(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IndustryItem[]>>> {
  return axios.get<TResponseWithQData<IndustryItem[]>>(
    API_ENDPOINTS.INDUSTRY_LIST,
    {
      params: qData,
    }
  );
}


export async function deleteIndustry(
  payload: { id: string | string[] }
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.INDUSTRY_DELETE, payload);
}
